module.exports = __webpack_public_path__ + "static/img/40004 (3).930f762.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40004 (3).webp
// module id = 2rTV
// module chunks = 14